import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MODAL_TYPE_SHARE_LINK } from '../../constants/modal-types';
import { openModal } from '../../actions/open-modal';
import PostSocialActions from '../../components/post-social-actions';

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openShareLinkModal: (url, focusOnCloseId) => {
        return openModal(MODAL_TYPE_SHARE_LINK, { url }, focusOnCloseId);
      },
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(PostSocialActions);



// WEBPACK FOOTER //
// ./app/containers/post-social-actions/index.js